import * as d3 from "d3";

export function render(data){

    d3.selectAll(".ljs--lattice-plot")
        .filter(d=> d.type == "scatterplot" && d.column == 0)
        .each(d=>{
            let plot = d3.select(`#${d.parentId}-scatterplot`);
            let circles = plot.selectAll(`.click`).data(data.filter(e=>e._info.cl == d._userInput.key))
            circles.exit().remove()
            circles
                .enter().append("circle")
                .merge(circles)
                .attr("cx", e=> d.scale.x(e.x))
                .attr("cy", e=> d.scale.y(e.y))
                .attr("r", 3)
                .attr("class", "click")
        })
}

export function clear(){
    d3.selectAll(".ljs--lattice-plot")
        .filter(d=> d.type == "scatterplot" && d.column == 0)
        .each(function(d){
            let plot =  d3.select(`#${d.parentId}-scatterplot`)
            plot.selectAll(`.click`).remove();
        })
}

export function point(config, data, classSelector){

        let plot = d3.select(".svg-plot g")
        let circle = plot.selectAll(`.${classSelector}`)
           .data(data)
      
        circle.exit().remove()
        circle.enter().append("circle")
            .merge(circle)
            .attr("cx", d=>config.scale.x(d.x))
            .attr("cy", d=>config.scale.x(d.y))
            .attr("r",d=>d.r*1.2)
            .attr("class", `${classSelector}`)
}
